import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { getExpireDate, getUserJwt } from "helpers";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

const Meter = (props) => {

    const dataContext = useContext(TemplateContext);
    const { content: formatContent, ...rest } = dataContext || {};
    // si no tengo props, busco contexto
    if(Object.keys(props).length === 0 && !!formatContent) {
          props = { 
              ...props,
              ...formatContent?.dataMeter,
          };
    } 

    const {
      metadata = {},
      tags = [],
      pageType = "",
      section = "",
      mainSectionTree = [],
      authors = "",
      paywall = "",
      typeWeb = "",
      authorName,
      sectionNames,
      newsId,
      category = ""
    } = props;

    const { loginWithRedirect ,isAuthenticated} = useAuth0();
    let pagegroups = pageType + ",";
    if (metadata?.payWallExclusive) {
      pagegroups += "payWallExclusive,";
    }
    let mainSection = "";
    if (mainSectionTree?.length > 0) {
      let mainSectionUrl = "";
      mainSectionUrl = mainSectionTree[0]?.url
        ? mainSectionTree[0]?.url
        : mainSectionTree[0]?.name.toLowerCase();
  
      mainSection =
        mainSectionTree &&
        !section?.includes(mainSectionUrl) &&
        mainSectionUrl + ",";
    }
  
    if (section != undefined && section) {
      pagegroups += mainSection ? mainSection + section : section;
    }
  
    let stringTags = "";
    if (tags) {
      for (let i = 0; i < tags.length; i++) {
        stringTags +=
          stringTags != ""
            ? "," + tags[i].name.toLowerCase()
            : tags[i].name.toLowerCase();
      }
    }
    
    pagegroups += typeWeb && "," + typeWeb;
  
    let author;
    if (authors) {
      author = authors;
    }
  
    pagegroups += "," + paywall;

    let pageTypeForDiv = pageType ? pageType : null;

    if(typeWeb == "live_blog") {
      pageTypeForDiv = typeWeb;
    } else if(category != "") { 
      pageTypeForDiv = category; 
    }
    

    useEffect(() => {
      window.auth0 = {};
      document.cookie = "auth0_redir=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      window.auth0.loginWithRedirect = () => {
        let expDate = getExpireDate(1);
        document.cookie = `auth0_redir=${window.location.href};expires=${expDate.toUTCString()}; path=/;`;
        loginWithRedirect();
      };
    
      window.getAccessTokenAuth0 = async () => {  
        if (isAuthenticated) {
          try {
            const token = getUserJwt();
      
            return token;
          } catch (e) {
            console.log("Error obteniendo el AccessToken", e);
          }
        } else {
          console.log("Error auth0 no Authenticated");
        }
      }
    }, [isAuthenticated]);
    
    
    return (
      <div
        id="wb_meter"
        apikey="BJ7C9NuU"
        pagegroups={pagegroups}
        tags={stringTags}
        autor={author}
        jwt=""
        authorname={authorName ? authorName : null}
        sectionnames={sectionNames ? sectionNames : null}
        pagetype={ pageTypeForDiv }
        newsid={newsId ? newsId : null}
        paywall={paywall ? paywall : null}
      />
    );
  };
  
  export default Meter;  